import React from "react"
import { Container } from "reactstrap"

const AppUpdate = ({ OS }) => {
  const link =
    OS === "android"
      ? "https://play.google.com/store/apps/details?id=com.prisms.one&hl=en_IN"
      : OS === "ios"
      ? "https://apps.apple.com/in/app/prisms-one/id6670251773?l=hi"
      : null;
      
  return (
    <>
      <Container
        style={{ backgroundColor: "#111" }}
        className="text-white p-3 mb-2 border rounded shadow-sm d-flex flex-column"
      >
        <div className="d-flex flex-column">
          <span className="text-danger fw-medium fs-5 mb-2">HIGH PRIORITY</span>
          <span className="fw-medium fs-5">
            Download the new version of the Prisms One app
          </span>
          <span
            className="fw-medium fs-5 mt-1"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => window.open(link, "_blank")}
          >
            Download
          </span>
        </div>
      </Container>
    </>
  )
}

export default AppUpdate
